var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border p-1 mb-2"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"d-flex flex-row justify-content-center"},[_c('h3',[_c('b-badge',{attrs:{"variant":"secondary"}},[_vm._v(_vm._s(_vm.data.total))])],1)]),_c('div',{staticClass:"d-flex flex-row justify-content-center"},[_c('p',[_vm._v(_vm._s(_vm.$t(_vm.data.name))+" ")])]),_c('div',{staticClass:"d-flex flex-row justify-content-center"},[_c('vue-apex-charts',{attrs:{"options":_vm.getDeviceChartOptions(),"height":"250px","width":"60%","series":[{
              name: _vm.$t('Working Engine'),
              data: [_vm.data.working],
              color:'#04d600'
            }, 
            {
              name: _vm.$t('Stopped Engine'),
              data: [_vm.data.stopped],
              color:'#FF1405'
            }, 
            {
              name: _vm.$t('Offline'),
              data: [_vm.data.offline],
              color:'#D6D5D5'
            }]}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }